import api from './api'

export const usersAPI = {
  list: () => api.get('/users.json'),
  get: (id) => api.get(`/users/${id}.json`),
  create: (data) => api.post('/users.json', { user: data }),
  update: (id, data) => api.patch(`/users/${id}.json`, { user: data }),
  delete: (id) => api.delete(`/users/${id}.json`),
}
